import React from "react"
import ContentLoader from "react-content-loader"

const SkeletonProductCard = (props) => (
  <ContentLoader
    speed={1}
    viewBox="0 0 768 1540"
    backgroundColor="#e8e8e8"
    foregroundColor="#d1d1d1"
    {...props}
  >
    <rect x="0" y="0" rx="0" ry="0" width="768" height="1152" />
    <rect x="0" y="1210" rx="0" ry="0" width="250" height="35" />
    <rect x="0" y="1290" rx="0" ry="0" width="350" height="35" />
    <rect x="0" y="1370" rx="0" ry="0" width="150" height="35" />
    <circle cx="30" cy="1500" r="30" />
    <circle cx="105" cy="1500" r="30" />
    <circle cx="180" cy="1500" r="30" />
    <circle cx="255" cy="1500" r="30" />
    <circle cx="330" cy="1500" r="30" />
    <circle cx="405" cy="1500" r="30" />
    <circle cx="480" cy="1500" r="30" />
  </ContentLoader>
)

export default SkeletonProductCard